<div style="display: flex; flex-direction: row;">
    <div class="snackbar-icon">
        <mat-icon>{{data.icon}}</mat-icon>
    </div>
    <div style="margin: 0;">
        <p class="snackbar-title">{{data.message}}</p>
        <p class="snackbar-label">{{data.description}}</p>
    </div>
</div>
